import { createSlice } from '@reduxjs/toolkit';
import { generateCsrfToken, logoutAdmin, logoutUser } from '~/api';
import { CSRF_TOKEN_NAME } from '~/constants/api';
import * as adminActions from '~/features/admin/adminSlice';
import * as userActions from '~/features/user/userSlice';

const initialState = {
  isChecked: {
    userRegistration: {
      terms: false,
      sign: false,
    },
  },
  isGeneratedCsrfToken: false,
};

const appCommonSlice = createSlice({
  name: 'appCommon',
  initialState,

  reducers: {
    changeTerms: (state, action) => {
      return {
        ...state,
        isChecked: {
          userRegistration: {
            ...action.payload.userRegistration,
          },
        },
      };
    },
  },
  extraReducers: {
    [generateCsrfToken.fulfilled.type]: (state, action) => {
      // CSRFの取得に成功したら自ドメインのcookieにセットする
      document.cookie = `${CSRF_TOKEN_NAME}=${action.payload.result.token}`;
      return {
        ...state,
        isGeneratedCsrfToken: true,
      };
    },

    // ログアウト時は初期化する
    [logoutAdmin.fulfilled.type]: () => initialState,
    [logoutUser.fulfilled.type]: () => initialState,

    // adminかuserで401エラーが発生したら初期化（ログイン画面に自動遷移したあと、再ログインの際にcsrfトークンを再生成できるように）
    [adminActions.unauthorizedErrorRaised]: () => initialState,
    [userActions.unauthorizedErrorRaised]: () => initialState,
  },
});

// sliceで定義したactionは全てexport
export const { changeTerms } = appCommonSlice.actions;

// reducerをexportする
export default appCommonSlice.reducer;
